// extracted by mini-css-extract-plugin
export default {"cms_switcher":"cms_switcher___d9oDa","cms_switcher_secondary":"cms_switcher_secondary___SB2mf"};